import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./style.module.scss";

import {
  setInfo,
  changeRepair,
  setComment,
} from "../../controllers/APIDataCallController/APIDataCallController";

import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

import {
  MapPin,
  Flame,
  ArrowRight,
  Bus,
  ActivityIcon,
  UserPenIcon,
  HammerIcon,
  CircleXIcon,
  FireExtinguisherIcon,
  PenOff,
  PencilLine,
} from "lucide-react";

import Modal from "../Modal/Modal";
import { MainContext } from "../../context/MainContext";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DisplayAddService from "../Modal/DisplayAddService/DisplayAddService";

function InfoCard({ icon, title, value, style, styleBox, styleValue }) {
  return (
    <div className={styles.card_info} style={style}>
      <div className={styles.card_info__icon}>{icon}</div>
      <div style={styleBox}>
        <span className={styles.card_info__title}>{title}</span>
        <span className={styles.card_info__value} style={styleValue}>
          {value}
        </span>
      </div>
    </div>
  );
}

function ActionButton({ icon, label }) {
  return (
    <div className={styles.card_action__btn}>
      <div className={styles.card_action__btn__content}>
        <span className={styles.card_action__btn__icon}>{icon}</span>
        <span>{label}</span>
      </div>
      <ArrowRight size={16} />
    </div>
  );
}

const formatPhoneNumber = (phone) => {
  return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, "+$1 ($2) $3-$4-$5");
};

// const { markers, setOpenModal } =
//   useContext(MainContext);

function CardMarker({ selectedMarker, setSelectedMarker, handleRoute, handleWaypoints }) {
  const { setOpenModal, setMarkers, user, setArchive } = useContext(MainContext);

  const [loading, setLoading] = useState(false);
  const [openRepair, setOpenRepair] = useState(false);
  const [openSetInfo, setOpenSetInfo] = useState(false);
  const [openService, setOpenService] = useState(false);
  const [openComment, setOpenComment] = useState(false);
  const [valueComment, setValueComment] = useState("");

  const [name, setName] = useState(selectedMarker.contact.name);
  const [phone, setPhone] = useState(selectedMarker.contact.tel);

  useEffect(() => {
    setValueComment(selectedMarker.comment);
  }, [selectedMarker]);

  const handleClickBtn = () => {
    setOpenModal(true);
    setOpenService(true);
  };

  const handleSetInfo = async () => {
    setLoading(true);
    await setInfo(user, selectedMarker, setMarkers, { name: name, tel: phone }, setArchive);
    setName("");
    setPhone("");
    setOpenSetInfo(!openSetInfo);
    setLoading(false);
  };

  const handleChangeRepair = async () => {
    setLoading(true);
    setOpenRepair(!openRepair);
    await changeRepair(user, selectedMarker, setMarkers, setArchive);
    setLoading(false);
  };

  const handleCreateComment = async () => {
    setLoading(true);
    setOpenComment(false);
    await setComment(user, selectedMarker, setMarkers, valueComment, setArchive);
    setValueComment("");
    setLoading(false);
  };

  return ReactDOM.createPortal(
    <div className={styles.card_wrapper}>
      <div className={styles.card}>
        <div className={styles.card_header}>
          <h1>{selectedMarker.name}</h1>
          <p className={styles.card_header_address}>{selectedMarker.city}</p>
          <p className={styles.card_header_address} style={{ fontSize: "11px" }}>
            {selectedMarker.type}
          </p>
          <p className={styles.card_header_address} style={{ fontSize: "11px" }}>
            ID {selectedMarker.id}
          </p>
          <button className={styles.card_header_close_btn} onClick={() => setSelectedMarker(null)}>
            <CircleXIcon color="#ff0e00" size={34} />
          </button>
        </div>

        <div className={styles.card_image}>
          <div className={styles.card_image_wrapper}>
            <img src={selectedMarker.photo} alt="Объект" />
          </div>
        </div>

        <Swiper
          modules={[EffectCoverflow, A11y]}
          style={{ height: "100%", width: "100%" }}
          spaceBetween={50}
          slidesPerView={1}
          scrollbar={{ draggable: true }}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          coverflowEffect={{
            rotate: 20,
            stretch: 0,
            depth: 150,
            modifier: 2,
            slideShadows: false,
          }}
        >
          <SwiperSlide>
            <div className={styles.card_info_grid}>
              <InfoCard
                icon={<MapPin />}
                title="Адрес"
                value={selectedMarker.address}
                style={{ gridColumn: "1 / 3" }}
              />
              <InfoCard
                title="Ответственный"
                value={selectedMarker.contact.name ? selectedMarker.contact.name : "Неизвестен"}
                style={{ gridColumn: "1 / 2" }}
                styleBox={{ maxWidth: "135px" }}
              />
              <InfoCard
                title="Телефон"
                value={
                  selectedMarker.contact.tel
                    ? formatPhoneNumber(selectedMarker.contact.tel)
                    : "Неизвестен"
                }
                style={{ gridColumn: "2 / 3" }}
                styleBox={{ maxWidth: "135px" }}
              />
              <InfoCard
                icon={<Flame />}
                title="Системы"
                value={selectedMarker.to ? selectedMarker.to : "АПС"}
                style={{ gridColumn: "1 / 3" }}
              />
              <InfoCard
                icon={<FireExtinguisherIcon />}
                title="Техническое обслуживание"
                value={selectedMarker.last_to ? selectedMarker.last_to : "Неизвестено"}
                style={{ gridColumn: "1 / 3" }}
              />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.card_info_grid}>
              <button className={styles.card_info_grid_btn} onClick={() => handleClickBtn()}>
                <InfoCard
                  icon={<ActivityIcon />}
                  title="Добавить ТО"
                  style={{ gridColumn: "1 / 3" }}
                />
              </button>
              <button className={styles.card_info_grid_btn} onClick={() => setOpenRepair(true)}>
                <InfoCard
                  icon={<HammerIcon />}
                  title={!selectedMarker.repair ? "Поставить на ремонт" : "Снять с ремонта"}
                  style={{ gridColumn: "1 / 3" }}
                />
              </button>
              <button className={styles.card_info_grid_btn} onClick={() => setOpenSetInfo(true)}>
                <InfoCard
                  icon={<UserPenIcon />}
                  title="Изменить номер Телефона"
                  style={{ gridColumn: "1 / 3" }}
                />
              </button>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.card_info_grid}>
              <InfoCard
                icon={<MapPin />}
                title="Адрес"
                value={selectedMarker.address}
                style={{ gridColumn: "1 / 3" }}
              />
              <InfoCard
                icon={<UserPenIcon />}
                title="Заметки"
                value={valueComment === "" ? "Заметки отсутствуют" : valueComment}
                style={{ gridColumn: "1 / 3", whiteSpace: "normal", overflow: "auto" }}
                styleValue={{ whiteSpace: "normal", overflow: "visible", textOverflow: "unset" }}
              />
              <button className={styles.card_info_grid_btn} onClick={() => setOpenComment(true)}>
                <InfoCard
                  icon={<UserPenIcon />}
                  title={valueComment === "" ? "Добавить Заметку" : "Изменить Заметку"}
                  style={{ gridColumn: "1 / 3" }}
                />
              </button>
            </div>
          </SwiperSlide>
        </Swiper>

        <div className={styles.card_action}>
          <button
            style={{ width: "100%" }}
            onClick={() => {
              handleRoute(selectedMarker.coordinates);
              handleWaypoints(selectedMarker);
              setSelectedMarker(null);
            }}
          >
            <ActionButton icon={<MapPin />} label="Маршрут" />
          </button>

          <button
            style={{ width: "100%" }}
            onClick={() => {
              handleWaypoints(selectedMarker);
              setSelectedMarker(null);
            }}
          >
            <ActionButton icon={<Bus />} label="Остановка" />
          </button>
        </div>
        {openService && (
          <Modal setOpenModal={setOpenModal} onClose={setOpenService}>
            <DisplayAddService handleClose={setOpenModal(false)} />
          </Modal>
        )}
        {openSetInfo && (
          <Modal setOpenModal={setOpenModal} onClose={() => setOpenSetInfo(false)}>
            <div className={styles.modal__wrapper}>
              <div className={styles.modal__title_container}>
                <h2 className={styles.modal__title}>Добавить информацию</h2>
              </div>
              <div className={styles.modal__text_container}>
                <p className={styles.modal__text}>{selectedMarker.name}</p>
                <p className={styles.modal__text}>{selectedMarker.address}</p>
              </div>
              <div className={styles.modal__container}>
                <p className={styles.modal__input_label}>Ответственный</p>
                <input
                  className={styles.modal__input_name}
                  type="text"
                  placeholder="Введите имя"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <p className={styles.modal__input_label}>Телефон</p>
                <div className={styles.modal__phone}>
                  <PhoneInput
                    country={"ru"}
                    value={phone}
                    containerClass="modal-phone-container"
                    inputClass="modal-phone-input"
                    onChange={(value) => setPhone(value)}
                  />
                </div>
              </div>
              <div className={styles.modal__button_container}>
                <button className={styles.modal__button_change} onClick={handleSetInfo}>
                  <PencilLine color="#ff0e00" size={20} />
                  Изменить
                </button>
                <button
                  className={styles.modal__button_close}
                  onClick={() => setOpenSetInfo(false)}
                >
                  <PenOff color="#ff0e00" size={20} />
                  Отменить
                </button>
              </div>
            </div>
          </Modal>
        )}
        {openRepair && (
          <Modal setOpenModal={setOpenModal} onClose={setOpenRepair}>
            <div className={styles.modal__wrapper}>
              <div className={styles.modal__title_container}>
                <h2 className={styles.modal__title}>{selectedMarker.name}</h2>
              </div>
              <div className={styles.modal__text_container}>
                <h5 className={styles.modal__text}>{selectedMarker.address}</h5>
              </div>
              <div className={styles.modal__text_container}>
                <p className={styles.modal__text}>
                  {!selectedMarker.repair ? "Поставить на ремонт" : "Снять с ремонта"}
                </p>
              </div>
              <div className={styles.modal__btn_container}>
                <button
                  variant="outlined"
                  className={styles.modal__btn_close}
                  onClick={() => handleChangeRepair()}
                >
                  {!selectedMarker.repair ? "Поставить" : "Снять"}
                </button>
              </div>
            </div>
          </Modal>
        )}
        {openComment && (
          <Modal setOpenModal={setOpenModal} onClose={setOpenComment}>
            <div className={styles.modal__wrapper}>
              <div className={styles.modal__title_container}>
                <h2 className={styles.modal__title}>{selectedMarker.name}</h2>
              </div>
              <div className={styles.modal__text_container}>
                <h5 className={styles.modal__text}>{selectedMarker.address}</h5>
              </div>
              <div className={styles.modal__text_container}>
                <textarea
                  id="comments"
                  className={styles.modal__textarea}
                  value={valueComment}
                  onChange={(e) => setValueComment(e.target.value)}
                  cols="30"
                  rows="10"
                ></textarea>
              </div>
              <div className={styles.modal__btn_container}>
                <button
                  variant="outlined"
                  className={styles.modal__btn_close}
                  onClick={() => handleCreateComment()}
                >
                  Изменить
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </div>,
    document.getElementById("modal-root"),
  );
  // return ReactDOM.createPortal(
  //   <div className={styles.marker__wrapper}>
  //     <div className={styles.marker}>
  //       <img
  //         src={selectedMarker.photo}
  //         className={styles.marker__photo}
  //         alt="logo"
  //         onError={(e) => {
  //           e.target.onerror = null;
  //           e.target.src = Image;
  //         }}
  //       />
  //       <div className={styles.marker__box}>
  //         <div className={styles.marker__box__info}>
  //           <h3 className={styles.marker__box__info__title}>{selectedMarker.name}</h3>
  //           <p className={styles.marker__box__info__city}>{selectedMarker.city}</p>
  //         </div>
  //         <p className={styles.marker__box__text}>{selectedMarker.type}</p>
  //         <p className={styles.marker__box__text}>
  //           {selectedMarker.last_to ? (
  //             selectedMarker.last_to
  //           ) : (
  //             <p style={{ color: "red" }}>ТО не проводилось!</p>
  //           )}
  //         </p>
  //         <BasicTabs />
  //       </div>
  //       <div className={styles.marker__box_button}>
  //         <button
  //           className={styles.marker__box_button__btn}
  //           onClick={() => {
  //             handleRoute(selectedMarker.coordinates);
  //             handleWaypoints(selectedMarker);
  //             setSelectedMarker(null);
  //           }}
  //         >
  //           Маршрут
  //         </button>
  //         <button
  //           className={styles.marker__box_button__btn}
  //           onClick={() => {
  //             handleWaypoints(selectedMarker);
  //             setSelectedMarker(null);
  //           }}
  //         >
  //           Остановка
  //         </button>
  //         <button
  //           className={styles.marker__box_button__btn}
  //           onClick={() => setSelectedMarker(null)}
  //         >
  //           Закрыть
  //         </button>
  //       </div>
  //     </div>
  //   </div>,
  //   document.getElementById("modal-root")
  // );
}

export default CardMarker;
